import { render, staticRenderFns } from "./Customized.vue?vue&type=template&id=35533130&lang=pug&"
import script from "./Customized.vue?vue&type=script&lang=js&"
export * from "./Customized.vue?vue&type=script&lang=js&"
import style0 from "./Customized.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports